// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

/**
* @description Model for Case Sessions
*/
export class CaseSessionModel {
    'sessionId'?: number;
    'surveyId'?: number | null;
    'creationTime'?: Moment;
    'createdBy'?: number;
    'surveySessionId'?: number | null;
    'documentId'?: number | null;
    'entityId'?: number | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof CaseSessionModel>> = [
        {
            "name":     "sessionId",
            "baseName": "sessionId",
            "type":     "number"
        },
        {
            "name":     "surveyId",
            "baseName": "surveyId",
            "type":     "number"
        },
        {
            "name":     "creationTime",
            "baseName": "creationTime",
            "type":     "Date"
        },
        {
            "name":     "createdBy",
            "baseName": "createdBy",
            "type":     "number"
        },
        {
            "name":     "surveySessionId",
            "baseName": "surveySessionId",
            "type":     "number"
        },
        {
            "name":     "documentId",
            "baseName": "documentId",
            "type":     "number"
        },
        {
            "name":     "entityId",
            "baseName": "entityId",
            "type":     "number"
        },
    ];

    static getAttributeTypeMap() {
        return CaseSessionModel.attributeTypeMap;
    }
}
